import Project from "../components/Project.jsx";
import { ProjectLinks, ProjectLink } from "../components/ProjectLinks.jsx";
import Typography from "@mui/material/Typography";

export default function Main() {
  return (
    <Project
      title="Health Insurance Price Negotiation [Ongoing]"
      picture={
        <p />
        // <img
        //   alt="graph"
        //   className="project-img"
        //   src={require("../pictures/nghttp2.jpg.avif")}
        //   width={400}
        // />
      }
      text={
        <Typography align="justify" sx={styles.text}>
          The Transparency in Coverage (TiC) Rule requires that group health
          plans and issuers to publicly disclose negotiated rates for providers.
          This large dataset can be used to negotiate better prices for
          healthcare for providers. So I built a web scraper to extract this
          data and uploaded it to an SQL database. Now I am building alogrithms
          to analyze and form pricing strategies, and a web app for data
          visualization. Come back soon for updates!
        </Typography>
      }
      links={
        <ProjectLinks>
          {/* <ProjectLink
            icon="github"
            link="https://github.com/brianiscoding/dylan"
          >
            Github
          </ProjectLink> */}
          <ProjectLink link="https://www.cms.gov/newsroom/fact-sheets/transparency-coverage-proposed-rule-cms-9882-p">
            Transparency In Coverage Rule
          </ProjectLink>
          {/* <ProjectLink link="https://www.andyl.com">Andyl</ProjectLink> */}
        </ProjectLinks>
      }
    />
  );
}

const styles = {
  text: {
    width: 0.9,
    fontSize: 20,
  },
};
